// extracted by mini-css-extract-plugin
export default {"container":"kl-z","bubbleNav":"ll-z","graphic":"ml-z","contact":"nl-z"};